import { Alert } from '../../../Alert';
import { HTML } from '../../../Html';
import type { SingleNotificationProps } from './SingleNotification.types';

export const SingleNotification = ({ id, message, html, onDismiss, ...otherProps }: SingleNotificationProps) => {
  return (
    <Alert id={id} text={html ? undefined : message} corner="rounded" closeable onClose={onDismiss} {...otherProps}>
      {html && <HTML html={message} />}
    </Alert>
  );
};
